import React from 'react';
import classNames from 'classnames';
import { AiOutlineDelete } from 'react-icons/ai';
import { FiKey } from 'react-icons/fi';
import styles from '@pages/api-portal/styles.module.scss';
import { StatusBadge } from '@pages/api-portal/status-badge';
import { formatCatalogDate } from '@pages/api-portal/utils';
import { SERVICE_PRINCIPAL_DOMAIN } from '@pages/api-portal/constants';
import { ServicePrincipal } from '@pages/api-portal/types';

interface ServicePrincipalCardProps {
    principal: ServicePrincipal;
    onRequestDelete: (principal: ServicePrincipal) => void;
}

/*
 * Single service-principal summary card with a delete action.
 */
export function ServicePrincipalCard({ principal, onRequestDelete }: ServicePrincipalCardProps) {
    return (
        <div className={styles.cardSplit} style={{ height: '100%' }}>
            <div className={styles.cardSplitBody}>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0, marginBottom: 8 }}>
                    <div className={styles.iconTile}>
                        <FiKey />
                    </div>
                    <div style={{ minWidth: 0 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <h5 className={styles.cardTitle} style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>
                                {principal.name}
                            </h5>
                            <StatusBadge status={principal.status} />
                        </div>
                    </div>
                </div>
                <p className={styles.mutedText} style={{ fontSize: 13, margin: 0, wordBreak: 'break-all' }}>
                    {principal.name}@{SERVICE_PRINCIPAL_DOMAIN}
                </p>
                {principal.createdBy && (
                    <p className={styles.mutedText} style={{ fontSize: 13, margin: '4px 0 0' }}>
                        {principal.createdBy}
                    </p>
                )}
            </div>
            <div className={styles.cardSplitFooter}>
                <span className={styles.mutedText} style={{ fontSize: 12 }}>
                    Created {formatCatalogDate(principal.created)}
                </span>
                <button
                    type="button"
                    className={classNames(styles.iconButton, styles.deleteAction)}
                    onClick={() => onRequestDelete(principal)}
                >
                    <AiOutlineDelete />
                </button>
            </div>
        </div>
    );
}
